// extracted by mini-css-extract-plugin
export default {"value":"aUvelIYyZyxDgrfuwALMhw=="};